import moment from "moment";

export const columns = [
  {
    accessorKey: "serialNumber",
    header: "Serial #",
    size: 150,
  },
  {
    accessorKey: "registrationNumber",
    header: "Vehicle",
    size: 140,
  },
  { accessorKey: "driverName", header: "Driver", size: 140 },
  {
    accessorKey: "vehicleType",
    header: "Type",
    size: 140,
  },
  { accessorKey: "vehicleStatus", header: "Status", size: 140 },
  { accessorKey: "paymentTypes", header: "Type of Payments", size: 210 },
  { accessorKey: "totalPayment", header: "Total Payment", size: 200 },
  {
    accessorKey: "totalPaymentReceived",
    header: "Payment Received",
    size: 210,
  },
  { accessorKey: "paymentStatus", header: "Payment Status", size: 200 },
  {
    accessorKey: "consignmentType",
    header: "Consignment ",
    size: 180,
  },
  {
    accessorKey: "gdNumber",
    header: "GD#",
    size: 140,
    accessorFn: (row: any) => ` ${row.gdNumber || " "}`,
  },
  {
    accessorKey: "deletedBy",
    header: "Deleted By",
    size: 170,
    accessorFn: (row: any) => ` ${row.deletedBy || " "}`,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 170,
    accessorFn: (row: any) => ` ${row.remarks || " "}`,
  },
  {
    accessorKey: "deletedAt",
    header: "Deleted At",
    size: 170,
    accessorFn: function customCell(row: any) {
      return `${row.deletedAt ? moment(row.deletedAt).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
];
